// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"WLnTYL","errorMessage":"rSNHo6","errorIcon":"PzL7AI","visuallyHidden":"adduJu"};